<div class="bg-white table-info-box mb-3">
  <div class="box-title">
    <h4 class="mb-0">{{ 'top-up.main-info' | translate }}</h4>
  </div>
  <div class="pt-3 px-3" nz-row [nzGutter]="[16, 16]">
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.list_date' | translate }}</div>
      <div class="content">{{ data.date | date: 'dd/MM/yyyy' }}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.seri' | translate }}</div>
      <div class="content">{{ data.seri }}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.type' | translate }}</div>
      <div class="content">
        <div class="content">{{ data.type ? (data.type.code + ' - ' + data.type.name) : ''}}</div>
      </div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'status.title' | translate }}</div>
      <div class="content">
        <ng-container *ngFor="let item of listStickerStatus">
          <span class="status-box" [ngClass]="item.class" *ngIf="item.value === data.status">{{ item.text | translate }}</span>
        </ng-container>
      </div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.stick_date' | translate }}</div>
      <div class="content">{{ data.posted_date | date: 'dd/MM/yyyy' }}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.stick_user' | translate }}</div>
      <div class="content">{{ data.posted_user ? (data.posted_user.first_name + ' ' + data.posted_user.last_name) : ''}}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.cancel_date' | translate }}</div>
      <div class="content">{{ data.cancelled_date | date: 'dd/MM/yyyy' }}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'sticker.cancel_user' | translate }}</div>
      <div class="content">{{ data.cancelled_user ? (data.cancelled_user.first_name + ' ' + data.cancelled_user.last_name) : ''}}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'created' | translate }}</div>
      <div class="content">{{ data.date_created | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'creator' | translate }}</div>
      <div class="content">{{ data.user_created ? (data.user_created.first_name + ' ' + data.user_created.last_name) : ''}}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'updated' | translate }}</div>
      <div class="content">{{ data.date_updated | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
    </div>
    <div nz-col nzSpan="6">
      <div>{{ 'updater' | translate }}</div>
      <div class="content">{{ data.user_updated ? (data.user_updated.first_name + ' ' + data.user_updated.last_name) : ''}}</div>
    </div>
  </div>
</div>
<div *nzModalTitle class="title-modal">{{'sticker.view' | translate}}</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{ 'close' | translate }}</button>
</div>
